type ErrorHandler = (err: Error) => void;

export class ErrorService {
    private errorHandlers: ErrorHandler[];

    constructor() {
        this.errorHandlers = [];
    }

    public addErrorHandler = (errorHandler: ErrorHandler): void => {
        this.errorHandlers = [...this.errorHandlers, errorHandler];
    };

    public removeErrorHandler = (errorHandler: ErrorHandler): void => {
        this.errorHandlers = this.errorHandlers.filter(handler => handler !== errorHandler);
    };

    public invokeError = (err: Error) =>
        this.errorHandlers.forEach(handler => handler(err));
}
